import { useCart } from "../context/CartContext.js";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { IoCartOutline } from "react-icons/io5";

const CartDrawer = ({ isOpen, onClose }) => {
  const { cartItems, removeFromCart } = useCart();

  return (
    <div
    className={`fixed top-0 mt-[82px] right-0 max-w-xl h-full rounded-lg overflow-y-auto bg-gray-100 shadow-xl transform transition-transform duration-300 z-50 ${
      isOpen ? "translate-x-0" : "translate-x-full"
    }`}
  >
      <div className="p-6">
        {/* Cart Header with Custom Border Color and Width */}
        <div className="flex justify-between items-center mb-6 border-b-2 border-[#FF9245] pb-4">
          <div className="flex items-center">
            <IoCartOutline className="h-8 w-8 text-[#ff9245]" />
            <p className="text-2xl ml-4 font-bold text-[#000000]">My Cart</p>
          </div>
          <button onClick={onClose} aria-label="Close Cart">
            <FontAwesomeIcon icon={faTimes} className="text-[#FF9245] text-2xl" />
          </button>
        </div>
    
        {/* Cart Items */}
        {cartItems.length === 0 ? (
          <div className="max-w-xl mx-auto bg-white shadow-lg rounded-lg p-4 mb-4">
            <p className="text-center text-xl text-gray-500">Your cart is empty.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {cartItems.map((item, index) => {
              // Parse the custom_excerpt string into an object
              const customExcerpt = JSON.parse(item.custom_excerpt);
    
              return (
                <div
                  key={index}
                  className="flex justify-between items-center bg-white shadow-lg rounded-lg border border-gray-200 p-4 mb-4"
                >
                  {/* College/Item Title */}
                  <div className="flex flex-col w-full">
                    {/* College Title */}
                    <h3 className="font-semibold text-lg text-gray-800">
                      {item.title}
                    </h3>
    
                    {/* Separator Line */}
                    <div className="flex items-center justify-center w-full">
                      <hr className="w-full border-t border-gray-300 my-2" />
                    </div>
    
                    {/* College Details */}
                    <div className="flex flex-col space-y-2 text-sm text-gray-600">
                      <p>
                        <strong>Counselling:</strong> {customExcerpt.location || "N/A"}
                      </p>
                      <p>
                        <strong>Course Offered:</strong>{" "}
                        {customExcerpt.courseOffered?.join(", ") || "N/A"}
                      </p>
                      <p>
                        {/* <strong>Reviews:</strong> {customExcerpt.reviewCount || "N/A"} */}
                      </p>
                      <p>{/* <strong>Fees:</strong> {customExcerpt.fees || "N/A"} */}</p>
                    </div>
                  </div>
    
                  {/* Remove Button */}
                  <div className="flex justify-end">
                    <button
                      className="text-red-500 font-semibold text-lg"
                      onClick={() => removeFromCart(item.id)}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
    
        {/* Conditionally render Checkout and Continue Shopping buttons */}
        {cartItems.length > 0 && (
          <>
            <Link href="/checkout" className="w-full mt-6 block text-center bg-[#FF9245] text-white py-3 rounded-lg font-bold">
              
                Checkout
              
            </Link>
    
            <Link href="/" className="w-full mt-3 block text-center text-[#FF9245] py-3 border border-[#FF9245] rounded-lg">
              
                Continue Shopping
              
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default CartDrawer;
